import * as React from 'react';
import classnames from 'classnames';

import Input from '@components/Input';

import ModalBase from './ModalBase';

import './style.scss';

interface IDeleteModalProps {
  show: boolean;
  disclaimerText: string;
  footer: any;
  classNames?: string;
  disclaimerAction?: string;
  disclaimerActionSubtext?: string;
  askReason?: boolean;
  reason?: string;
  onReasonChange?: any;
  reasonError?: IFieldValidation;
  title: string;
  reasonLabel: string;
}

interface IDeleteModalState {}

export default class DeleteModal extends React.Component<IDeleteModalProps, IDeleteModalState> {
  static defaultProps: IDeleteModalProps = {
    show: false,
    disclaimerText: 'Are You Sure?',
    footer: null,
    classNames: '',
    title: null,
    reasonLabel: '',
  };

  renderBody = () => (
    <div className={classnames('disclaimer-modal__body', 'flex-column--center')}>
      <div className={classnames('disclaimer-modal__disclaimer-img')} />
      <h4 className={classnames('disclaimer-modal__disclaimer-text')}>{this.props.disclaimerText}</h4>
      {this.props.disclaimerAction && (
        <div className={classnames('disclaimer-modal__action-text')}>{this.props.disclaimerAction}</div>
      )}
      {this.props.disclaimerActionSubtext && (
        <div className={classnames('disclaimer-modal__action-subtext')}>{this.props.disclaimerActionSubtext}</div>
      )}
      {this.props.askReason && (
        <Input
          field={{
            label: this.props.reasonLabel,
            value: this.props.reason,
            isRequired: false,
            type: CustomFieldType.TEXTAREA,
          }}
          onChange={this.props.onReasonChange}
          error={this.props.reasonError}
        />
      )}
    </div>
  );

  render() {
    const { classNames, footer } = this.props;

    return (
      <ModalBase
        show={this.props.show}
        onClose={() => null}
        titleElement={null}
        bodyElement={this.renderBody()}
        footerElement={footer}
        className={classnames('disclaimer-modal', classNames)}
      />
    );
  }
}
